export default {
  Certification: 'Certifications',
  SkillsAndLanguages: 'Skills & Languages',
  WorkHistory: 'Work History',
  Personality: 'Personality',
  Availability: 'Availability',
  Travel: 'Travel',
  Eligibility: 'Eligibility',
  Contact: 'Contact',
  Agreements: 'Agreements',
  Confirm: 'Confirm',
  Interview: 'Interview',
};
